import { render, staticRenderFns } from "./_ubett.vue?vue&type=template&id=ca6d9590&lang=pug&"
import script from "./_ubett.vue?vue&type=script&lang=js&"
export * from "./_ubett.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports